
import Oidc from 'oidc-client'
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { __DEV__ } from '@/params/config';
import config from '@/params/config';
@Component({
  components: {}
})
export default class DocMarkdown extends Vue {
  iframeH: any = 200;
  mdType: any = '';
  version: any = 'v1';
  system: any = '';
  sysType:any={};
  @Getter sysList: any;

  @Action('getSysList') getSysList: Function;
  get verList() {
    const vers =
      (this.sysList.infos &&
        this.sysList.infos.filter((item: any) => item.type === this.mdType)) ||
      [];
    if (vers.length > 0) {
      return vers[0] && vers[0].vers;
    } else {
      return [];
    }
  }
  get docSource() {
    let host = window.location.host;    
    const protocol = window.location.protocol || 'http:';
    if (host.indexOf('cpzy.') === -1) {
      host = 'cpzy.mingyuanyun.com';
    }
    if(process.env.NODE_ENV === 'test'){
      host = '10.5.11.27:8000';
    }
    const mdType = {
      cailiao: 'docs_clcp',
      caizhao: 'wd_czxt_730',
      chengben: 'productdoc',
      shoulou: 'ekfn',
      jihua: 'fn_jhxt',
      feiyong: 'docs_fyxt',
      highdata: 'cpwdk',
      zhushuju: 'wdzx_zsj',
      touzishouyi: 'wd_tzsy',
      shangcheng: 'sc_docs'
    };
    
    const src = `${protocol}//${host}/doc/${this.version}/${
      (mdType as any)[this.mdType]
    }/index.html`;    

    const iframe =
      '<iframe src="' +
      src +
      '" frameborder="no" width="100%" height="' +
      this.iframeH +
      '"></iframe>';

    return iframe;
  }
  created() {
     this.sysType = {
      Cl: 'cailiao',
      Cz: 'caizhao',
      Cb: 'chengben',
      Sl: 'shoulou',
      Jh: 'jihua',
      Fy: 'feiyong',
      Hd: 'highdata',
      Zsj: 'zhushuju',
      Tzsy: 'touzishouyi',
      Sc: 'shangcheng'
    };        
    //	this.mdType=sysType['Sl'];
    //  this.rdcLogin();       
    

    this.getSysList();
  }
  mounted() {
    window.addEventListener("message", this.setsystemcode, false );
		// 通知打开页面的主体，页面加载完成
		window.opener.postMessage("加载完成", config.tjHost);


    this.iframeH = window.innerHeight- 65 - 85;

    window.addEventListener('resize', () => {
      this.iframeH = window.innerHeight- 65 - 85;
    });
  }
    
  @Watch('verList', { immediate: true, deep: true })
  watchSys(newVal: any) {    
    this.version = (this.verList[0] && this.verList[0].value) || 'v1';
  }
  
  setsystemcode(event:any){    
		if(event.origin===config.tjHost){ 
        if (event.data) {
        this.mdType = this.sysType[event.data];      	       
        }else{   
        window.location.href=config.tjHost; 	       
      }
	  }
  }

  rdcLogin(){
    var configs = {
      authority: config.VUE_APP_AUTHORITY,
      client_id: config.VUE_APP_CLIENT_ID,
      redirect_uri: config.VUE_APP_REDIRECT_URI,
      response_type: config.VUE_APP_RESPONSE_TYPE,
      scope: config.VUE_APP_SCOPE,
      post_logout_redirect_uri: config.VUE_APP_POST_LOGOUT_REDIRECT_URI,
      response_mode: config.VUE_APP_RESPONSE_MODE
    }

    if (window.localStorage.getItem('access_token'))  {      
      return;
    }

    window.localStorage.setItem('redirect','/documents/TJmdreview');
    const mgr = new Oidc.UserManager(configs)
    mgr.signinRedirect()
  }
}
